import { Typography } from 'components/Text/TextStyle/TextStyle';
import { CaptionFontWeights } from './Caption';

export const computeCaptionTypography = (captionFontWeights: CaptionFontWeights): Typography =>
    `Caption/${captionFontWeights}/Caption1`;
